import { render } from "./AppItem.vue?vue&type=template&id=633a8f08"
import script from "./AppItem.vue?vue&type=script&lang=js"
export * from "./AppItem.vue?vue&type=script&lang=js"

import "./AppItem.vue?vue&type=style&index=0&id=633a8f08&lang=postcss"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__